/**
 * @flow
 * @relayHash 6f39d84e89820336434a6868879ee3d6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type licensePrice_track$ref = any;
export type licensePrice_QueryVariables = {|
  trackSlug?: ?string,
  usages?: ?$ReadOnlyArray<?{
    spot_count?: ?number,
    term?: ?number,
    medium: number,
    contextual_param?: ?$ReadOnlyArray<?number>,
    contextual_param_type: string,
  }>,
|};
export type licensePrice_QueryResponse = {|
  +track: ?{|
    +$fragmentRefs: licensePrice_track$ref,
  |},
|};
*/


/*
query licensePrice_Query(
  $trackSlug: String
  $usages: [LicenseUsageParamsInput]
) {
  track(slug: $trackSlug, license_params: $usages) {
    ...licensePrice_track
    id
  }
}

fragment licensePrice_track on TrackSearchResult {
  id
  internal_id
  price
  base_price
  title
  added_to_cart
  slug
  duration
  score
  boosted_score
  stems_available
  customizable
  matched_exclusions
  tempos {
    id
    name
    value
  }
  assets {
    id
    version
    type
    file_format
    path
    metadata
  }
  artist {
    id
    name
    slug
    bio
    bandcamp
    facebook
    instagram
    itunes
    soundcloud
    spotify
    twitter
    wiki
    youtube
    homebase
    assets {
      id
      version
      type
      file_format
      path
      metadata
    }
  }
  terms(first: 100) {
    edges {
      node {
        id
        is_highlighted
        name
        parent_id
        taxonomy {
          id
          internal_id
          name
        }
      }
    }
  }
  collections {
    edges {
      node {
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
      }
      id
    }
  }
  association_id
  selected_version
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "trackSlug",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "usages",
    "type": "[LicenseUsageParamsInput]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "license_params",
    "variableName": "usages",
    "type": "[LicenseUsageParamsInput]"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "trackSlug",
    "type": "String"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "licensePrice_Query",
  "id": null,
  "text": "query licensePrice_Query(\n  $trackSlug: String\n  $usages: [LicenseUsageParamsInput]\n) {\n  track(slug: $trackSlug, license_params: $usages) {\n    ...licensePrice_track\n    id\n  }\n}\n\nfragment licensePrice_track on TrackSearchResult {\n  id\n  internal_id\n  price\n  base_price\n  title\n  added_to_cart\n  slug\n  duration\n  score\n  boosted_score\n  stems_available\n  customizable\n  matched_exclusions\n  tempos {\n    id\n    name\n    value\n  }\n  assets {\n    id\n    version\n    type\n    file_format\n    path\n    metadata\n  }\n  artist {\n    id\n    name\n    slug\n    bio\n    bandcamp\n    facebook\n    instagram\n    itunes\n    soundcloud\n    spotify\n    twitter\n    wiki\n    youtube\n    homebase\n    assets {\n      id\n      version\n      type\n      file_format\n      path\n      metadata\n    }\n  }\n  terms(first: 100) {\n    edges {\n      node {\n        id\n        is_highlighted\n        name\n        parent_id\n        taxonomy {\n          id\n          internal_id\n          name\n        }\n      }\n    }\n  }\n  collections {\n    edges {\n      node {\n        id\n        description\n        name\n        slug\n        category {\n          id\n          name\n        }\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n      }\n      id\n    }\n  }\n  association_id\n  selected_version\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "licensePrice_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "licensePrice_track",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "licensePrice_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "track",
        "storageKey": null,
        "args": v1,
        "concreteType": "TrackSearchResult",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "stems_available",
            "args": null,
            "storageKey": null
          },
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "price",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "base_price",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "added_to_cart",
            "args": null,
            "storageKey": null
          },
          v3,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "duration",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "score",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "boosted_score",
            "args": null,
            "storageKey": null
          },
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "customizable",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "matched_exclusions",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tempos",
            "storageKey": null,
            "args": null,
            "concreteType": "Tempo",
            "plural": true,
            "selections": [
              v2,
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "value",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "artist",
            "storageKey": null,
            "args": null,
            "concreteType": "Artist",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "itunes",
                "args": null,
                "storageKey": null
              },
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "bio",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "bandcamp",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "facebook",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "instagram",
                "args": null,
                "storageKey": null
              },
              v5,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "soundcloud",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "spotify",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "twitter",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "wiki",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "youtube",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "homebase",
                "args": null,
                "storageKey": null
              },
              v6
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "terms",
            "storageKey": "terms(first:100)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100,
                "type": "Int"
              }
            ],
            "concreteType": "TaxonomyTermConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TaxonomyTermEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TaxonomyTerm",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "is_highlighted",
                        "args": null,
                        "storageKey": null
                      },
                      v5,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "parent_id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "taxonomy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Taxonomy",
                        "plural": false,
                        "selections": [
                          v2,
                          v4,
                          v5
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "collections",
            "storageKey": null,
            "args": null,
            "concreteType": "CollectionTrackConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CollectionTrackEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Collection",
                    "plural": false,
                    "selections": [
                      v2,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "description",
                        "args": null,
                        "storageKey": null
                      },
                      v5,
                      v3,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CollectionCategory",
                        "plural": false,
                        "selections": [
                          v2,
                          v5
                        ]
                      },
                      v6
                    ]
                  },
                  v2
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "association_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_version",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '2846b1994a37171622748e7523f61278';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/licensePrice_Query.graphql.js